import { observable, action } from "mobx";
import {getByAtribute} from "../../../utils/formatar";

export default class TabelaStore {
    @observable selected;
    @observable ordenacao;

    constructor() {
        this.selected = [];
        this.resetOrdenacao();
    }

    resetOrdenacao = () => {
        this.ordenacao = {
            field: null,
            asc: true
        }
    };

    onSelectAll = (isSelected, lista, keyField) => {
        if(lista){
            if (isSelected) {
                for(let i=0;i<lista.length;i++) {
                    lista[i].isSelected = isSelected;
                }
                this.selected = lista.map(row => {
                    return row[keyField];
                });
            } else {
                for(let i=0;i<lista.length;i++) {
                    lista[i].isSelected = isSelected;
                }
                this.selected = [];
            }
        }
    };

    setOrdenacao(field, tableRef) {
        if(tableRef) {
            if(this.ordenacao.field === field) {
                this.ordenacao.asc = !this.ordenacao.asc;
                tableRef.handleSort(this.ordenacao.asc ? 'asc' : 'desc', field)
            } else {
                this.ordenacao.asc = false;
                this.ordenacao.field = field;
                tableRef.handleSort('desc', field)
            }
        } else {
            console.log("referência a tabela não encontrada")
        }
    }


    onRowSelect = (obj, keyField) => {
        if (!obj.isSelected) {
            this.selected = [...this.selected, obj[keyField]];
        } else {
            this.selected = this.selected.filter(it => it !== obj[keyField])
        }
        obj.isSelected = !obj.isSelected;
        return false;
    };
}



// WEBPACK FOOTER //
// ./src/modules/comum/stores/TabelaStore.js